module.exports = __webpack_public_path__ + "static/img/12.bc52082e.jpg";